define(function(require,exports,module){
    var DeviceInteraction = require( "../DeviceInteraction" );

    function extend(target, source){
        var key;
        for(key in source){
            target[key] = source[key];
        }
        return target;
    }

    function AndroidDispatcher(options){
        this.deepLinkPrefix = options.deepLinkPrefix;
    }

    AndroidDispatcher.prototype.buildLink = function(params){
        
        if (!this.deepLinkPrefix) {
            return false;
        }

        var prefix = this.deepLinkPrefix;
        var paramsConfig = params.queries;
        var type = params.type
        var query = Object.keys(paramsConfig).map(function(k) {
            return k + '=' + paramsConfig[k];
        }).join('&');
        return prefix + '://' + type + '?'+ query;
    };


    AndroidDispatcher.prototype.publish = function(params){
        const deeplinkUrl = this.buildLink(params);
        if (deeplinkUrl) {
            window.location.replace(this.buildLink(params));
        }
    }

    function AndroidInteraction(options){
    
        this.dispatcher = new AndroidDispatcher({
            deepLinkPrefix: options.deepLinkPrefix || this.deepLinkPrefix
        });

        AndroidInteraction.superclass.constructor.call(this);
    }

    AndroidInteraction.isDispatcherAvailable = /Android/.test(navigator.userAgent);

    DeviceInteraction.spawn(AndroidInteraction)
        .define({
            type    : "android",
            deepLinkPrefix : 'mlbatbat',
            video       : function(data){ 
                this.dispatcher.publish({
                    queries: {
                        "article" : data.vid || data.id
                    },
                    type  : 'video'
                });
                return true;
            },
            playercard  : function(data){
                this.dispatcher.publish({
                    queries: {
                        "player_id" : data.playerId || data.pid
                    },
                    type  : 'athlete'
                });
                return true;
            },
            openArticle     : function(data){
                this.dispatcher.publish({
                    queries: {
                        "article" : data.contentId || ''
                    },
                    type  : 'news'
                });
                return true;
            },
            track       : function(data){
                return true;
            },
            articleshare : function(data){
               return true
            },
            share       : function(data){
                return true;
            },
            photo       : function(data){
                return true;
            },
            audio       : function(data){
                return true;
            },
            nhltv       : function(data){
                return true;
            },
            milbtv      : function(data){
                return true;
            },
            has60fps    : function(){
                return true;
            },
            hasAccess   : function(id){
                return true;
            },
            isDispatcherActive : function(){
                return !!this.dispatcher;
            },
            gameday : function(data){
                this.dispatcher.publish({
                    queries: {
                        "gamepk" : data.gamePk
                    },
                    type  : 'game'
                });
                return true;
            },
            mlbtvapp : function(data){
                let datetime = '';
                if (!!data.date) { 
                    var date = data.date.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3") + 'T10:00:00';
                    datetime = new Date(date).getTime()
                }
                this.dispatcher.publish({
                    queries: {
                        "gamepk" : data.gamePk,
                        "date": datetime
                    },
                    type  : 'mlbtv'
                });
                return true;
            },
            milbtvapp : function(data){
                this.dispatcher.publish({
                    queries: {
                        "gamepk" : data.gamePk
                    },
                    type  : 'milbtv'
                });
                return true;
            },
            tvapp : function(data){
                switch (this.dispatcher.deepLinkPrefix) {
                    case 'milbfirstpitch':
                        this.milbtvapp(data);
                        break;
                    default:
                        this.mlbtvapp(data);
                }
                return true;
            },
            team   : function() {
                // note: there is no deep link on android right now
                return false;
            },
        });
    return AndroidInteraction;
});
